import { useLocation, useNavigate, useSearch } from '@tanstack/react-router';
import { useCallback } from 'react';

import { useSavedQueries } from './use-saved-queries';
import { useWorkspaceId } from './use-workspace-id';

const QUERY_PARAM_KEY = 'q';

export function useSelectedSavedQueryId() {
  const { q } = useSearch({ strict: false }) as { q: string };
  return q;
}

export function useSelectedSavedQuery() {
  const { workspaceId } = useWorkspaceId();
  const { data: savedQueries } = useSavedQueries({ workspaceId });
  const navigate = useNavigate();
  const location = useLocation();
  const { q } = useSearch({ strict: false }) as { q: string };

  const setQuery = useCallback(
    ({ queryId, replace = false }: { queryId: string; replace?: boolean }) => {
      const searchParams = new URLSearchParams(location.search);
      searchParams.set(QUERY_PARAM_KEY, queryId);

      navigate({
        to: location.pathname,
        search: Object.fromEntries(searchParams),
        replace,
      });
    },
    [navigate, location.pathname, location.search],
  );

  const selectedQuery = savedQueries?.find((query) => query.id === q);

  if (!selectedQuery) throw new Error(`Selected query not found : ${q}`);

  return {
    query: selectedQuery,
    setQuery,
  };
}
